import type { ComponentType } from 'react';
import type { UseControllerProps } from 'react-hook-form';
import { useController } from 'react-hook-form';

export function withController<TProps>(Component: ComponentType<TProps>) {
  return (props: UseControllerProps<any> & TProps & { className?: string }) => {
    const {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      field: { ref: _ref, value, ...restField },
      fieldState: { error },
    } = useController({
      name: props.name,
      rules: props.rules,
      control: props.control,
    });
    const isRequiredField = (props.rules?.required as any)?.value;
    return (
      <Component
        {...restField}
        value={value ?? ''}
        {...props}
        error={!!error}
        errorMsg={error?.message}
        className={`${props.className ? props.className : ''} ${
          isRequiredField ? 'required' : ''
        }`}
      />
    );
  };
}
